import { makeEntityScaffold } from '@classpass/saga-tools';
import { CLASS_ENTITY_TYPE } from 'constants/logic';
import { transformClientResponse, transformKeysToSnakeCase } from 'helpers/core';

import URLS from 'constants/urls';

/* 
  Query params:
    - onlyActive: when true returns only classes that have associated schedule between 90 days in the past and 14 days ahead
    - includeDisabled: when true includes classes that are disabled in Legacy DB, 'passport_classes' table, 'disabled' column
*/

const handler = (
  { httpClient },
  {
    venueId,
    onlyActive = false,
    entityType = CLASS_ENTITY_TYPE.CLASS,
    includeClassPricing = false,
    includeDisabled = false,
    source,
  }
) => {
  const params = transformKeysToSnakeCase({
    onlyActive,
    includeDisabled,
    entityType,
    includeClassPricing,
    source,
  });
  const endpoint = URLS.venue.classes(venueId);

  return httpClient.get(endpoint, { params }).then(transformClientResponse);
};

export default makeEntityScaffold('SAGA.API.VENUE_CLASSES', handler, { defaultKey: (_, { venueId = '' }) => venueId });
